module.exports = __webpack_public_path__ + "static/img/user-propile-level03.d80d8dee.svg";